import { Company } from '../../api/services/company/types.ts'
import { Invoice, Position } from '../../api/services/invoice/types.ts'
import { convertToShortDate } from '../formatter.ts'
import {
  address,
  formatDate,
  getCurrentTimestamp,
  monthsInPeriod,
  vatSymbol
} from './helpers.ts'

// - Struktura danych EDI++ wersja 1.09
// jest dostępna pod adresem:
// https://forum.insert.com.pl/applications/core/interface/file/attachment.php?id=31029

function prepareInfoSection(
  company: Company,
  fromDate: string,
  toDate: string,
  fromDateRaw: string,
  toDateRaw: string
): string {
  return [
    '1.09',
    '0',
    '1250',
    'Dietetyk 24 - Panel',
    'firma',
    `"${company.company_name}"`,
    `"${company.company_name}"`,
    `"${company.city}"`,
    `"${company.postal_code}"`,
    `"${address(company)}"`,
    `"${company.nip}"`,
    'DD',
    'Dietetyk24',
    'Faktury kosztowe - STRIPE',
    '',
    `${monthsInPeriod(fromDateRaw, toDateRaw)}`, // Dane z okresu (następujące daty są istotne) Logiczne
    fromDate,
    toDate,
    '1',
    `${getCurrentTimestamp()}`, // Kiedy została wykonana komunikacja
    'POLSKA',
    'PL',
    `PL${company.nip}`,
    '1'
  ].join(',')
}

function prepareNaglowek(invoice: Invoice, counter: number): string[] {
  const recipient = invoice.recipient_company_data
  const issuer = invoice.issuing_company_data
  // Używa pierwszej pozycji, możesz zmienić logikę, np. sumować całość
  const pos = invoice.positions[0]

  const sumNet = invoice.positions.reduce((sum, item) => {
    const unitNet = (
      Number(item.unit_price) / Number(1 + item.vat_rate / 100)
    ).toFixed(2)
    const totalNet = (Number(unitNet) * item.quantity).toFixed(2)

    return sum + Number(totalNet)
  }, 0)

  const sumVAT = invoice.positions.reduce((sum, item) => {
    const unitNet = (
      Number(item.unit_price) / Number(1 + item.vat_rate / 100)
    ).toFixed(2)
    const totalNet = (Number(unitNet) * item.quantity).toFixed(2)
    const totalVAT = (Number(item.total_price) - Number(totalNet)).toFixed(2)

    // const totalVAT = Number(item.total_price) * (item.vat_rate / 100)
    return sum + Number(totalVAT)
  }, 0)
  const sumGross = invoice.positions.reduce((sum, item) => {
    return sum + parseFloat(item.total_price)
  }, 0)

  return [
    // Podstawowe parametry
    '"FS"',
    '1',
    '0',
    `${counter}`, // numer pozycji lub faktury wg kolejności
    '',
    '',
    `"${invoice.invoice_number}"`, // numer faktury
    '',
    '',
    '',
    '',

    // Kontrahent
    `"${recipient.nip}"`, // albo inne ID odbiorcy (jeśli pole dostępne)
    `"${recipient.name}"`,
    `"${recipient.name}"`,
    `"${recipient.city}"`,
    `"${recipient.postal_code}"`,
    `"${address(recipient)}"`,
    `"${recipient.nip}"`,

    // Kategoria dokumentu
    '"Sprzedaż"',
    '"Sprzedaż dla klienta"',

    // Miejsce i data wystawienia
    `"${recipient.city}"`,
    `${convertToShortDate(invoice.created_at)}`, // data wystawienia
    `${convertToShortDate(invoice.sales_date)}`, // data sprzedaży
    '',

    // Pozycje
    `${invoice.positions.length}`,

    // Cena na dokumencie
    '0', // Czy dokument wystawiany wg cen netto Logiczne
    '"Podstawowa"',

    // Wartość i koszt dokumentu
    `${sumNet.toFixed(2)}`,
    `${sumVAT.toFixed(2)}`,
    `${sumGross.toFixed(2)}`,
    '0', // koszt

    // Rabat i forma płatności
    '"0,00"',
    '0.0000',
    '"Płatność online"', // forma płatności
    `${convertToShortDate(invoice.sales_date)}`,

    // Kwoty na dokumencie
    pos?.total_price ?? '0.00', // Kwota zapłacona przy odbiorze dokumentu
    pos?.total_price ?? '0.00', // Wartość do zapłaty

    // Zaokrąglenie i przeliczenie
    '0',
    '0',
    '1',
    '0',

    // Osoby związane z dokumentem
    `"${issuer.name}"`,
    `"${issuer.name}"`,
    '',

    // Opakowania
    '0.0000',
    '0.0000',

    // Waluta dokumentu
    '"PLN"',
    '1.0000',

    // Inne parametry
    '',
    '',
    '',
    '',
    '0',
    '0',
    '0',

    // Płatności kartą i kredytowe
    '',
    '0.0000',
    '',
    '0.0000',
    '"POLSKA"', // kraj odbiorcy
    '"PL"', // kod kraju odbiorcy
    '0'
  ]
}

function prepareZawartosc(position: Position): string[] {
  const unitNet = (
    Number(position.unit_price) / Number(1 + position.vat_rate / 100)
  ).toFixed(2)
  const totalNet = (Number(unitNet) * position.quantity).toFixed(2)
  const totalVAT = (Number(position.total_price) - Number(totalNet)).toFixed(2)

  return [
    vatSymbol(position.vat_rate),
    `${position.vat_rate}`,
    totalNet,
    totalVAT,
    position.total_price
  ]
}

export function generateEppFromInvoices(
  invoices: Invoice[],
  issuingCompany: Company,
  fromDateRaw: string,
  toDateRaw: string
): string {
  const fromDate = formatDate(fromDateRaw)
  const toDate = formatDate(toDateRaw)

  const infoSection = prepareInfoSection(
    issuingCompany,
    fromDate,
    toDate,
    fromDateRaw,
    toDateRaw
  )
  let lines = ['[INFO]', infoSection]

  invoices.forEach((invoice, index) => {
    lines.push('')
    lines.push('[NAGLOWEK]')
    lines.push(prepareNaglowek(invoice, index + 1).join(','))

    invoice.positions.forEach((position) => {
      lines.push('')
      lines.push('[ZAWARTOSC]')
      lines.push(prepareZawartosc(position).join(','))
    })
  })

  return lines.join('\n')
}
